import { CherryHubAdminApi } from "../../api/adminApiModels";

export const createEmptyPassConfigurationRule =
  (): CherryHubAdminApi.PassConfigurationRule => ({
    PassConfigurationId: "",
    IsEnabled: true,
    Description: "",
    Test: "",
    ApplyWhenTestFails: false,
  });

export const getOrderedPassConfigurationRuleEntries = (
  rules: CherryHubAdminApi.PassConfigurationRulesMap | null | undefined
): Array<[string, CherryHubAdminApi.PassConfigurationRule]> =>
  Object.entries(rules ?? {}).sort(
    ([leftKey], [rightKey]) => parseInt(leftKey) - parseInt(rightKey)
  );

export const passConfigurationRulesMapToArray = (
  rules: CherryHubAdminApi.PassConfigurationRulesMap | null | undefined
): CherryHubAdminApi.PassConfigurationRule[] =>
  getOrderedPassConfigurationRuleEntries(rules).map(([, rule]) => ({
    ...rule,
  }));

export const passConfigurationRulesArrayToMap = (
  rules: CherryHubAdminApi.PassConfigurationRule[] | null | undefined
): CherryHubAdminApi.PassConfigurationRulesMap => {
  const normalizedRules: CherryHubAdminApi.PassConfigurationRulesMap = {};
  (rules ?? []).forEach((rule, index) => {
    normalizedRules[index.toString()] = { ...rule };
  });

  return normalizedRules;
};
